export const TOGGLE_SIDEBAR = 'aiAssistant/TOGGLE_SIDEBAR';
export const SET_SIDEBAR_VISIBLE = 'aiAssistant/SET_SIDEBAR_VISIBLE';
export const SET_SIDEBAR_COLLAPSED = 'aiAssistant/SET_SIDEBAR_COLLAPSED';

export const UPDATE_CONTEXT = 'aiAssistant/UPDATE_CONTEXT';

export const ADD_MESSAGE = 'aiAssistant/ADD_MESSAGE';
export const UPDATE_MESSAGE = 'aiAssistant/UPDATE_MESSAGE';
export const CLEAR_MESSAGES = 'aiAssistant/CLEAR_MESSAGES';

export const SET_CONVERSATION_ID = 'aiAssistant/SET_CONVERSATION_ID';
export const SET_TYPING = 'aiAssistant/SET_TYPING';

export const SET_PENDING_ACTION = 'aiAssistant/SET_PENDING_ACTION';
export const CLEAR_PENDING_ACTION = 'aiAssistant/CLEAR_PENDING_ACTION';

export const SEND_MESSAGE_REQUEST = 'aiAssistant/SEND_MESSAGE_REQUEST';
export const SEND_MESSAGE_SUCCESS = 'aiAssistant/SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_FAILURE = 'aiAssistant/SEND_MESSAGE_FAILURE';

export const EXECUTE_ACTION_REQUEST = 'aiAssistant/EXECUTE_ACTION_REQUEST';
export const EXECUTE_ACTION_SUCCESS = 'aiAssistant/EXECUTE_ACTION_SUCCESS';
export const EXECUTE_ACTION_FAILURE = 'aiAssistant/EXECUTE_ACTION_FAILURE';

export const LOAD_CONVERSATION_REQUEST = 'aiAssistant/LOAD_CONVERSATION_REQUEST';
export const LOAD_CONVERSATION_SUCCESS = 'aiAssistant/LOAD_CONVERSATION_SUCCESS';
export const LOAD_CONVERSATION_FAILURE = 'aiAssistant/LOAD_CONVERSATION_FAILURE';

export const SET_ERROR = 'aiAssistant/SET_ERROR';
export const CLEAR_ERROR = 'aiAssistant/CLEAR_ERROR';
